import { Category } from "~/generated/rtk-query/nowdo-live-api.generated";

export type CategorizedItems<T> = {
  order: number;
  categoryName: Category["name"];
  categoryId: Category["id"];
  items: T[];
};

export const categorizeItems = <T extends Partial<{ category: Category }>>(categories: Category[], items: T[]) => {
  // categoryからは削除されたが、classroomには残っているcategoryがあるかもしれないので、classroomからもcategoryを取得します
  // categoriesと重複している部分は下の方のfilterで除去されます
  const categorizedItems = [
    ...categories,
    ...items.filter((classroom) => classroom.category?.name).map((classroom) => classroom.category),
  ].map(
    (category: Category, i): CategorizedItems<T> => ({
      order: i,
      categoryName: category.name,
      categoryId: category.id,
      items: [],
    })
  );

  const other = categories.find((category) => category.name === "その他");

  items.forEach((item) => {
    let c = item;
    // 既に修正したクラスルーム作成時のバグで {id: '', name: ''} が残っている可能性がある為、それはその他に入れておきます
    if (!item.category?.id && other) {
      c = {
        ...item,
        category: other,
      };
    }
    const targetCategoryItem = categorizedItems.find((value) => value.categoryId === c.category?.id);
    targetCategoryItem?.items.push(c);
  });

  return categorizedItems
    .filter((classroom) => classroom.items.length > 0)
    .sort((a, b) => {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    });
};
